import { Component, OnInit, Input, OnChanges, SimpleChanges, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { IssueTypeHelper } from '@solar/solar/models';
import { SupervisionError} from 'solar-bo';


@Component({
  selector: 'app-issuethermal',
  templateUrl: './issuethermal.component.html',
  styleUrls: ['./issuethermal.component.scss']
})
export class IssueThermalComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() issue:SupervisionError;
  @Input() options:{showDate:boolean}={showDate:true};
  showTempMeasuresMin=false;

  constructor() { }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    let typeChange = changes['issue'];
    if (typeChange && !typeChange.firstChange) {
    }
  }

  ngAfterViewInit(){

  }
  /**
   * Show the description of an issue 
   * @param issue 
   */
  ui_errortype(issue) {
    return IssueTypeHelper.issueGetErrorTypeDescription(issue.type);
  }

  ui_relevance(issue) {
    if (!issue) {
      return "";
    }

    if (issue.info){
      return issue.info.relevance;
    }
  }
}
